<div class="header" *ngIf="this.user.customerId == null">
  
  <button 
    class="sidebar-toggle-btn-external" 
    (click)="toggleSidebarVisibility()"
    [class.collapsed]="!isSidebarVisible">
    <i class="fas" [class.fa-chevron-left]="isSidebarVisible" [class.fa-chevron-right]="!isSidebarVisible"></i>
  </button>

  <div [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme" 
       [class.sidebar-hidden]="!isSidebarVisible"
       (mouseover)="sidebarHover()"
       (mouseout)="sidebarHover()">

    <div class="sidebar-wrapper">
      <div class="app-sidebar-scroll">
        <div class="logo-container">
          <div class="logo-section" style="height:100%;width:100%">
            <ng-container>
              <img src="/assets/images/Roomease.jpg" class="DarAtlassLogo logo-image">
            </ng-container>
          </div>
        </div>


      
          <div class="v-sidebar-menu vsm-default">
            <div class="vsm-list">


              <div class="vsm-header" (click)="indexo !== 2 && toggleReseaSubMenu(0)" [class.disabled]="indexo == 2">
                Reservation
                <i
                  [ngClass]="{'vsm-arrow-down': reservationSubMenuOpen, 'vsm-arrow-right': !reservationSubMenuOpen}"></i>


              </div>

              <div *ngIf="reservationSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                  {{item.name}}
                </div>
              </div>



              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !==2 && toggleFrontSubMenu(1)"
                [class.disabled]="indexo == 2">
                Front Desk
                <i [ngClass]="{'vsm-arrow-down': frontDSubMenuOpen, 'vsm-arrow-right': !frontDSubMenuOpen}"></i>


              </div>
              <div *ngIf="frontDSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                  {{item.name}}
                </div>
                <div class="vsm-item1" *ngIf="sideBarMatrix[index][0].children.length !== 0"
                  (click)="toggleisSubMenu('')">
                  <i class="fas fa-tools"></i>

                  <i [ngClass]="{'vsm-arrow-down': isSubMenuOpen, 'vsm-arrow-right': !isSubMenuOpen}"></i>
                </div>


              </div>



              <div *ngIf="showedChaifer" class="vsm-header" (click)="indexo !== 2 && toggleCrmSubMenu(11)"
                [class.disabled]="indexo == 2">
                Crm
                <i [ngClass]="{'vsm-arrow-down': CrmSubMenuOpen, 'vsm-arrow-right': !CrmSubMenuOpen}"></i>
              </div>
              <div *ngIf="CrmSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i>
                  {{item.name}}
                </div>
              </div>

              <!-- House-keeping with sub-menu -->
              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !==2 && toggleHousekeepingSubMenu(3)"
                [class.disabled]="indexo == 2">
                House-keeping
                <i
                  [ngClass]="{'vsm-arrow-down': housekeepingSubMenuOpen, 'vsm-arrow-right': !housekeepingSubMenuOpen}"></i>
              </div>
              <div *ngIf="housekeepingSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                  {{item.name}}
                </div>
              </div>


              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="toggleBackSubMenu(2)">
                Back Office
                <i [ngClass]="{'vsm-arrow-down': backSubMenuOpen, 'vsm-arrow-right': !backSubMenuOpen}"></i>
              </div>
              <div *ngIf="backSubMenuOpen" class="vsm-submenu">

                <div class="vsm-item1" *ngIf="sideBarMatrix[index][0].children.length !== 0" style="font-weight: bold;"
                  (click)="toggleisSubMenu('BackOffice')">
                  <i class="fas fa-tools"></i>
                  Settings
                  <i [ngClass]="{'vsm-arrow-down': isSubMenuOpen, 'vsm-arrow-right': !isSubMenuOpen}"></i>
                </div>
                <div *ngIf="isSubMenuOpen" class="vsm-submenu">
                  <div *ngFor="let item of sideBarMatrix[index][0].children" class="vsm-item"
                    [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                    routerLink="{{item.route}}">
                    <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                    {{item.name}}
                  </div>
                </div>
                <div class="vsm-item1" *ngIf="sideBarMatrix[index][1].children.length !== 0" style="font-weight: bold;"
                  (click)="toggleis1SubMenu('BackOffices')">
                  <i class="fas fa-band-aid"></i>
                  BO Processing
                  <i [ngClass]="{'vsm-arrow-down': is1SubMenuOpen, 'vsm-arrow-right': !is1SubMenuOpen}"></i>
                </div>
                <div *ngIf="is1SubMenuOpen" class="vsm-submenu">
                  <div *ngFor="let item of sideBarMatrix[index][1].children" class="vsm-item"
                    [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                    routerLink="{{item.route}}">
                    <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                    {{item.name}}
                  </div>
                </div>
                <div class="vsm-item1" (click)="toggleis2SubMenu('BackOffices')"
                  *ngIf="sideBarMatrix[index][2].children.length !== 0" style="font-weight: bold;">
                  <i class="fas fa-file-alt"></i>
                  Report
                  <i [ngClass]="{'vsm-arrow-down': is2SubMenuOpen, 'vsm-arrow-right': !is2SubMenuOpen}"></i>
                </div>
                <div *ngIf="is2SubMenuOpen" class="vsm-submenu">
                  <div *ngFor="let item of sideBarMatrix[index][2].children" class="vsm-item"
                    [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                    routerLink="{{item.route}}">
                    <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                    {{item.name}}
                  </div>
                </div>

              </div>



              <div *ngIf="User?.userId != 459" class="vsm-header" [class.disabled]="indexo == 2">
                <a href="http://beds.fractalite.com/#/properties/2/rate-bases" [class.disabled]="indexo == 2">
                  Rate Management
                </a>
              </div>

              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && toggleReportingSubMenu()"
                [class.disabled]="indexo == 2">
                Reporting Analytics
                <i [ngClass]="{'vsm-arrow-down': reportingSubMenuOpen, 'vsm-arrow-right': !reportingSubMenuOpen}"></i>
              </div>
              <div *ngIf="reportingSubMenuOpen" class="vsm-submenu">

                <div class="vsm-item" routerLink="admin/dashboard">
                  <i class="fas fa-chart-line"></i> <!-- Icone pour Genarating Daily Reports -->
                  Dashboard (General Manager)
                </div>

                <div class="vsm-item"routerLink="front-desk/dashKpi">
                  <i class="fas fa-tachometer-alt"></i> 
                  KPI Dashboard
                </div>
                
                <div class="vsm-item" routerLink="front-desk/customerOver">
                  <i class="fas fa-chart-bar"></i> 
                  Sales Dashboard
                </div>
                
                <div class="vsm-item" routerLink="front-desk/reception">
                  <i class="fas fa-concierge-bell"></i> 
                  Reception Planning
                </div>
                
                <div class="vsm-item" routerLink="front-desk/logs">
                  <i class="fas fa-dollar-sign"></i>
                  Paiement Logs
                </div>

                <div class="vsm-item" routerLink="admin/pickups">
                  <i class="fas fa-chart-bar extra-sales-icon"></i> <!-- Icône mise à jour -->
                  Pickups
                </div>
                <div class="vsm-item" routerLink="front-desk/Night-Price-Report">
                  <i class="fas fa-chart-line"></i> <!-- Icône mise à jour -->
                  Night Price Report
                </div>

                <div class="vsm-item" routerLink="front-desk/Occupancy-Admin">
                  <i class="fas fa-chart-line"></i> <!-- Icône mise à jour -->
                  Occupancy Report
                </div>

                <div class="vsm-item" routerLink="front-desk/Revenue-Analysis-Report">
                  <i class="fas fa-chart-line"></i> <!-- Icône mise à jour -->
                  Revenue Report
                </div>

                <div class="vsm-item" routerLink="front-desk/Reports">
                  <i class="fas fa-chart-line"></i> <!-- Icone pour Genarating Daily Reports -->
                  Front Desk Reports
                </div>
                <div class="vsm-item" routerLink="front-desk/reservations-export">
                  <i class="fas fa-file-export extra-sales-icon"></i> <!-- Icône suggestive pour l'export -->
                  Export Reservations
                </div>
                <div class="vsm-item" routerLink="front-desk/Kpis/channel" *ngIf="showedChaifer">
                  <i class="fas fa-network-wired updated-icon"></i> <!-- Icône mise à jour -->
                  Channels
                </div>
                <div class="vsm-item" routerLink="front-desk/Kpis/customer" *ngIf="showedChaifer">
                  <i class="fas fa-user-friends updated-icon"></i> <!-- Icône mise à jour -->
                  Customers
                </div>

                <div class="vsm-item" routerLink="front-desk/Kpis/market" *ngIf="showedChaifer">
                  <i class="fas fa-store market-icon"></i> <!-- Icône mise à jour -->
                  Market
                </div>


                <div class="vsm-item" routerLink="front-desk/End-of-Day-history">
                  <i class="fas fa-moon night-audit-icon"></i> <!-- Icône mise à jour -->
                  Night Audit
                </div>
                <div class="vsm-item" routerLink="front-desk/taxes">
                  <i class="fas fa-file-invoice-dollar tax-icon"></i>
                  Taxes
                </div>
                <div class="vsm-item" routerLink="front-desk/tax">
                   <i class="fas fa-file-invoice-dollar tax-icon"></i>
                   TPT & TS
                </div>
                <div class="vsm-item" routerLink="front-desk/rapproch">
                  <i class="fas fa-file-invoice-dollar tax-icon"></i>
                  CMI Rapprochement
                </div>
                <div class="vsm-item" routerLink="reports/extra-sales">
                  <i class="fas fa-chart-bar extra-sales-icon"></i> <!-- Icône mise à jour -->
                  Extra Sales
                </div>
                <div class="vsm-item" [routerLink]="['/reports/extra-sales']" [queryParams]="{ free: true }">
                  <i class="fas fa-chart-bar extra-sales-icon"></i>
                  Free Items
                </div>
                <div class="vsm-item" [routerLink]="['/reports/free-stay']">
                  <i class="fas fa-chart-bar extra-sales-icon"></i>
                  Free Stays
                </div>
                <div class="vsm-item" routerLink="reports/extra-sales-new">
                  <i class="fas fa-chart-bar extra-sales-icon"></i> <!-- Icône mise à jour -->
                  Free Items Details
                </div>
                <div class="vsm-item" routerLink="front-desk/Forecast">
                  <i class="fas fa-cloud-sun forecast-icon"></i> <!-- Icône mise à jour -->
                  Forecast
                </div>
                <div class="vsm-item" routerLink="front-desk/free-reservations">
                  <i class="fas fa-calendar-check forecast-icon"></i>
                  Free Reservations
                </div>
                <div class="vsm-item" routerLink="front-desk/StatByNationality" *ngIf="showedChaifer">
                  <!--                      <i class="fas fa-moon night-audit-icon"></i> &lt;!&ndash; Icône mise à jour &ndash;&gt;-->
                  <i class="fas fa-flag nationality-icon"></i>
                  Stats By Nationality
                </div>
                <div class="vsm-item" routerLink="front-desk/DailyReport">
                  <i class="fas fa-calendar-day report-icon"></i> <!-- Icône de rapport journalier -->
                  Daily Reports
                </div>
                <div class="vsm-item" routerLink="front-desk/Report-Bacs">
                  <i class="fas fa-file-invoice-dollar report-detail-icon"></i>
                  Report Bacs
                </div>
                <div class="vsm-item" routerLink="front-desk/DailyReportDetailCA">
                  <i class="fas fa-file-invoice-dollar report-detail-icon"></i>
                  Daily Details CA
                </div>
                <div class="vsm-item" routerLink="front-desk/DiscountReport" *ngIf="showedChaifer">
                  <i class="fas fa-percentage discount-report-icon"></i>
                  Discount Reports
                </div>

              </div>



              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && togglePaymentSubMenu(6)"
                [class.disabled]="indexo == 2">
                Payment Processing
                <i [ngClass]="{'vsm-arrow-down': paymentSubMenuOpen, 'vsm-arrow-right': !paymentSubMenuOpen}"></i>

              </div>
              <div *ngIf="paymentSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i> <!-- Icône pour le tableau de bord administrateur -->
                  {{item.name}}
                </div>

              </div>
              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && toggleComptaSubMenu(10)"
                [class.disabled]="indexo == 2">
                Accounting
                <i [ngClass]="{'vsm-arrow-down': comptaSubMenuOpen, 'vsm-arrow-right': !comptaSubMenuOpen}"></i>
              </div>
              <div *ngIf="comptaSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i>
                  {{item.name}}
                </div>
              </div>

               <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && toggleReconcilliationSubMenu(14)"
                [class.disabled]="indexo == 2">
                Module de Lettrage
                <i [ngClass]="{'vsm-arrow-down': comptaSubMenuOpen, 'vsm-arrow-right': !comptaSubMenuOpen}"></i>
              </div>
              <div *ngIf="ReconcilliationSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i>
                  {{item.name}}
                </div>
              </div>

              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && toggleEndSubMenu()"
                [class.disabled]="indexo == 2">
                End-of-Day

                <i [ngClass]="{'vsm-arrow-down': endSubMenuOpen, 'vsm-arrow-right': !endSubMenuOpen}"></i>
              </div>
              <div *ngIf="endSubMenuOpen" class="vsm-submenu">
                <div class="vsm-item" [class.selected]="selectedItem === 'End-of-Day'"
                  (click)="selectItem('End-of-Day')" routerLink="front-desk/End-of-Day">
                  <i class="fas fa-cog"></i>
                  Control
                </div>

              </div>

              <div class="vsm-header" (click)="indexo !== 2 && toggleMarketingSubMenu(12)"
                [class.disabled]="indexo == 2">

                Audit
                <i [ngClass]="{'vsm-arrow-down': marketingSubMenuOpen, 'vsm-arrow-right': !marketingSubMenuOpen}"></i>
              </div>

              <div *ngIf="marketingSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">

                  <i class="{{item.icon}}"></i>
                  {{ item.name }}
                </div>
              </div>

              <div class="vsm-header" (click)="indexo !== 2 && toggleStdnSubMenu(13)"
                [class.disabled]="indexo == 2">
                STDN Declaration
                <i [ngClass]="{'vsm-arrow-down': stdnSubMenuOpen, 'vsm-arrow-right': !stdnSubMenuOpen}"></i>
              </div>

              <div *ngIf="stdnSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[index]" class="vsm-item"
                  [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                  routerLink="{{item.route}}">
                  <i class="{{item.icon}}"></i>
                  {{ item.name }}
                </div>
              </div>
              

              <div *ngIf="User?.userId != 459" class="vsm-header" (click)="indexo !== 2 && toggleAdminSubMenu(9)"
                [class.disabled]="indexo == 2">
                Admin
                <i [ngClass]="{'vsm-arrow-down': adminSubMenuOpen, 'vsm-arrow-right': !adminSubMenuOpen}"></i>
              </div>

              <div *ngIf="adminSubMenuOpen" class="vsm-submenu">
                <div *ngFor="let item of sideBarMatrix[activeAdminIndex]" 
                     class="vsm-item"
                     [class.selected]="selectedItem === item.name"
                     (click)="selectItem(item.name)"
                     [routerLink]="item.route">
                  <i [class]="item.icon"></i> {{item.name}}
                </div>
              </div>
              
              <!-- <div *ngIf="adminSubMenuOpen" class="vsm-submenu">
                <ng-container *ngFor="let item of sideBarMatrix[index]">
                
                  <div *ngIf="item.name !== 'Exchange rate' || canExchangeRate" class="vsm-item"
                    [class.selected]="selectedItem === item.name" (click)="selectItem(item.name)"
                    [routerLink]="item.route">
                    <i [class]="item.icon"></i>
                    {{ item.name }}
                  </div>
                </ng-container>
              </div> -->

            </div>
          </div>
          <div>
            <button type="button" class="btn btn-light" (click)="sendToSupport()"
              style="margin-left:30%">Support</button>
          </div>
       


      </div>
    </div>
  </div>
</div>

<div class="header" style="width: 200%;" *ngIf="this.user.customerId !== null">

  <!-- <button 
    class="sidebar-toggle-btn" 
    (click)="toggleSidebarVisibility()"
    [class.collapsed]="!isSidebarVisible">
    <i class="fas" [class.fa-bars]="!isSidebarVisible" [class.fa-times]="isSidebarVisible"></i>
  </button> -->

  <div [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme" (mouseover)="sidebarHover()"
    (mouseout)="sidebarHover()">

    <div class="app-sidebar-content">
      <div class="app-sidebar-scroll">

        <div class="logo-container">
          <div class="logo-section" style="height:100%;width:100%">
            <ng-container>
              <img src="/assets/images/Roomease.jpg" class="DarAtlassLogo logo-image">
            </ng-container>
          </div>

        </div>


        <perfect-scrollbar [autoPropagation]="true" style="margin-top: 20px;">
          <div class="v-sidebar-menu vsm-default">
            <div class="vsm-list">
              <div class="vsm-submenu">
                <div class="vsm-item" routerLink="front-desk/reservations-management">
                  <i class="fas fa-file-invoice-dollar report-detail-icon"></i>
                  New Reservation
                </div>
                <div class="vsm-item" routerLink="front-desk/reservationslist">
                  <i class="fas fa-percentage discount-report-icon"></i>
                  Reservations
                </div>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-light" (click)="sendToSupport()"
              style="margin-left:30%">Support</button>
          </div>
        </perfect-scrollbar>


      </div>
    </div>
  </div>
</div>